import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { AdminTab } from '@/constants/adminTabs';
import { User } from '@supabase/supabase-js';
import { LogOut, Menu } from 'lucide-react';
import { useState } from 'react';
import MobileAdminAccordion from './AdminMobileAccordion';

interface Props {
  tabs: AdminTab[];
  activeTab: string;
  setActiveTab: (key: string) => void;
  user: User | null;
  onSignOut: () => void;
}

const MobileAdminNavbar = ({
  tabs,
  activeTab,
  setActiveTab,
  user,
  onSignOut,
}: Props) => {
  const [open, setOpen] = useState(false);

  const propertyTabs = tabs.filter(
    (tab) => tab.group === 'property' && tab.key !== 'todos',
  );
  const businessTabs = tabs.filter((tab) => tab.group === 'business');

  const handleSelectTab = (key: string) => {
    setActiveTab(key);
    setOpen(false);
  };

  const fullName = `${user?.user_metadata?.first_name ?? ''} ${
    user?.user_metadata?.last_name ?? ''
  }`.trim();

  const email = user?.email ?? '';

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative rounded-full border bg-blue-50 hover:bg-blue-50 hover:scale-105 transition-all"
          aria-label="Abrir menú"
        >
          <Menu size={20} className="text-brand-primary" />
        </Button>
      </SheetTrigger>

      <SheetContent
        side="left"
        className="max-[450px]:w-full w-72 p-4 flex flex-col justify-between"
      >
        <div className="space-y-4">
          <Button
            onClick={() => handleSelectTab('dashboard')}
            variant="ghost"
            className="p-0 flex gap-2 items-center hover:bg-transparent"
          >
            <img
              src="/lovable-uploads/icono-estancia-corta.png"
              alt="Icono de Estancia Corta"
              className="w-8 h-8 object-contain"
            />

            <h2 className="font-semibold text-lg">Menú</h2>
          </Button>

          <ScrollArea className="h-full">
            <MobileAdminAccordion
              propertyTabs={propertyTabs}
              businessTabs={businessTabs}
              activeTab={activeTab}
              onSelectTab={handleSelectTab}
            />
          </ScrollArea>
        </div>

        <div className="pt-4 border-t space-y-2">
          <div className="flex flex-col items-start gap-0.5 cursor-default focus:bg-transparent">
            <span className="text-md font-medium truncate">{fullName}</span>
            <span className="text-sm text-muted-foreground truncate">
              {email}
            </span>
          </div>

          <Button
            variant="ghost"
            className="w-full justify-start gap-2 p-0 text-destructive hover:text-primary hover:bg-transparent"
            onClick={onSignOut}
          >
            <LogOut className="w-4 h-4" />
            Cerrar sesión
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileAdminNavbar;
